import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';

import dataManager from '../DataManager';

import styles from './Login.module.css';

function Login() {
  const navigate = useNavigate();

  const signInWithApple = () => {
    dataManager.signInWithApple((error) => {
      if (error) {
        console.error('Sign in error:', error);
      } else {
        console.log("Sign in successful");
        navigate('/Inbox');
      }
    });
  };

  return (
    <div className={styles.loginContainer}>
      <img src={`${process.env.PUBLIC_URL}/logo196.png`} alt="JotSync Logo" className={styles.loginIcon} />
      <h1 className={styles.loginHeader}>JotSync</h1>
      <Button color="primary" onClick={signInWithApple}>
        Sign in with Apple
      </Button>
    </div>
  );
}

export default Login;
